'use es6';

import Networks from 'ads-account-connection/lib/Networks';
export const LEARN_MORE_URLS = {
  [Networks.FACEBOOK]: 'https://www.facebook.com/business/tools/ads-manager',
  [Networks.ADWORDS]: 'https://ads.google.com/intl/en_us/getstarted/?subid=us-en-cm-aw-z-a-hubs!o3',
  [Networks.LINKEDIN]: 'https://www.linkedin.com/campaignmanager/new-advertiser'
};
export const AD_CREDIT_URLS = {
  [Networks.ADWORDS]: 'https://www.hubspot.com/products/marketing/google-ads#Promocode',
  [Networks.LINKEDIN]: 'https://www.hubspot.com/linkedin-ads#TermsCondition'
};